import React from 'react';

const PreLoader = () => {
    return (
        <div className="preloader">
        <div className="preloader-body">
        <span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div className="base">
          <span></span>
          <div className="face"></div>
        </div>
      </div>
      <div className="longfazers">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      </div>
    )
}

export default PreLoader;
